module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4QoHAAse31CmNwAAANRJREFUWMPtlz0OwjAMhWOrOxISnXo9zpAr0DNwNEaYsnGCxxTJQvlpWuJEIp7bvi/PbvRMAExJrTQnX7BwVPK9qVT0upw2P7sFhnIOrDQjJxqr++udhYgC+JPsFZcQKTeCAEdOXeoGa4h7J0MDzBriKQg2jYu1Th9zgQCoics6Px/UtAXeheYzQDdzUbdf3g39/AUDYAD8L4CFIx8atO8AC0ejBezzmmYbZDxjGaE1IL6zYV8zUNuFUDLm0GpVAyIWy/tcTLpYzfY6Itv3k+W09nr+AevjmsxxfmwqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/puyo_r.png
// module id = Bcqc
// module chunks = 1